import React from 'react'
import { CToast, CToastBody, CToastClose } from '@coreui/react-pro'

const FeedbackToast = ({ t, toastVisible, setToastVisible, isError, customMessage }) => {
  return (
    <CToast
      autohide={true}
      delay={5000}
      visible={toastVisible}
      color={isError ? 'danger' : 'success'}
      className='success-toast text-white align-items-center'
    >
      <div className='d-flex'>
        <CToastBody>{customMessage ? customMessage : ( isError ? t('FailureToastMessage') : t('SuccessToastMessage') ) }</CToastBody>
        <CToastClose className='me-2 m-auto' white onClick={() => setToastVisible(false)} />
      </div>
    </CToast>
  )
}
export default FeedbackToast
